import React from 'react';

const SellerHome = () => {
  return <div className="App"></div>;
};

export default SellerHome;
